import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  howManyDevices,
  largeFiles,
  moving,
  onlineGaming,
  onlineGamingD,
  peopleSimultaneously,
  peopleSimultaneouslyE,
  peopleWorkingFromHome,
  postalCode,
  streamingVideoQuality,
  streamingVideoQualityE,
  internetSpeedOrHelp,
  internetSpeed,
  internetSpeedD,
  provincesStep,
  currentProviderInternet,
  currentProviderInternetD,
  movingStep,
  valueCustomerOpinions,
  movingStepInternetC,
  valueCostEfficiency,
  valuePrice,
  valueTheMostChoices1,
  valueTheMostChoices1E,
  // valueTheMostChoices2,
  // valueTheMostChoices2E,
  homePhoneNeeded,
  addressLocationInternet,
  postalCodeF,
  onlineGamingG,
  // internetSpeedG,
  streamingVideoQualityG,
  sliderData,
  internetSpeedG,
} from './internet-steps'

export const internetScenarioA: Scenario = {
  id: 'internet-a',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.INTERNET,
  milestones: [
    provincesStep.id,
    currentProviderInternet.id,
    moving.id,
    peopleSimultaneously.id,
    howManyDevices.id,
    peopleWorkingFromHome.id,
    streamingVideoQuality.id,
    onlineGaming.id,
    largeFiles.id,
    postalCode.id,
  ],
  version: '1',
  steps: [
    provincesStep,
    currentProviderInternet,
    moving,
    peopleSimultaneously,
    howManyDevices,
    peopleWorkingFromHome,
    streamingVideoQuality,
    onlineGaming,
    largeFiles,
    postalCode,
  ],
  weight: 0,
}

export const internetScenarioB: Scenario = {
  id: 'internet-b',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.INTERNET,
  milestones: [
    provincesStep.id,
    currentProviderInternet.id,
    movingStep.id,
    internetSpeedOrHelp.id,
    internetSpeed.id,
    peopleSimultaneously.id,
    howManyDevices.id,
    peopleWorkingFromHome.id,
    streamingVideoQuality.id,
    onlineGaming.id,
    largeFiles.id,
    postalCode.id,
  ],
  version: '1',
  steps: [
    provincesStep,
    currentProviderInternet,
    movingStep,
    internetSpeedOrHelp,
    internetSpeed,
    peopleSimultaneously,
    howManyDevices,
    peopleWorkingFromHome,
    streamingVideoQuality,
    onlineGaming,
    largeFiles,
    postalCode,
  ],
  weight: 0,
}

export const internetScenarioC: Scenario = {
  id: 'internet-c',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.INTERNET,
  milestones: [
    provincesStep.id,
    currentProviderInternet.id,
    movingStepInternetC.id,
    valueCustomerOpinions.id,
    valueCostEfficiency.id,
    valuePrice.id,
    internetSpeedOrHelp.id,
    internetSpeed.id,
    peopleSimultaneously.id,
    howManyDevices.id,
    peopleWorkingFromHome.id,
    streamingVideoQuality.id,
    onlineGaming.id,
    largeFiles.id,
    postalCode.id,
  ],
  version: '1',
  steps: [
    provincesStep,
    currentProviderInternet,
    movingStepInternetC,
    valueCustomerOpinions,
    valueCostEfficiency,
    valuePrice,
    internetSpeedOrHelp,
    internetSpeed,
    peopleSimultaneously,
    howManyDevices,
    peopleWorkingFromHome,
    streamingVideoQuality,
    onlineGaming,
    largeFiles,
    postalCode,
  ],
  weight: 0,
}

export const internetScenarioD: Scenario = {
  id: 'internet-d',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.INTERNET,
  milestones: [
    provincesStep.id,
    currentProviderInternetD.id,
    internetSpeedOrHelp.id,
    internetSpeedD.id,
    peopleSimultaneously.id,
    howManyDevices.id,
    peopleWorkingFromHome.id,
    streamingVideoQuality.id,
    onlineGamingD.id,
    valueTheMostChoices1.id,
    // valueTheMostChoices2.id,
    postalCode.id,
  ],
  version: '1',
  steps: [
    provincesStep,
    currentProviderInternetD,
    internetSpeedOrHelp,
    internetSpeedD,
    peopleSimultaneously,
    howManyDevices,
    peopleWorkingFromHome,
    streamingVideoQuality,
    onlineGamingD,
    valueTheMostChoices1,
    // valueTheMostChoices2,
    postalCode,
  ],
  weight: 0,
}

export const internetScenarioE: Scenario = {
  id: 'internet-e',
  initialStep: Steps.CURRENT_PROVIDER,
  type: ScenarioType.INTERNET,
  milestones: [
    currentProviderInternetD.id,
    internetSpeedOrHelp.id,
    internetSpeedD.id,
    peopleSimultaneouslyE.id,
    peopleWorkingFromHome.id,
    streamingVideoQualityE.id,
    onlineGamingD.id,
    valueTheMostChoices1.id,
    // valueTheMostChoices2E.id,
    homePhoneNeeded.id,
    postalCode.id,
  ],
  version: '1',
  steps: [
    currentProviderInternetD,
    internetSpeedOrHelp,
    internetSpeedD,
    peopleSimultaneouslyE,
    peopleWorkingFromHome,
    streamingVideoQualityE,
    onlineGamingD,
    valueTheMostChoices1E,
    // valueTheMostChoices2E,
    homePhoneNeeded,
    postalCode,
  ],
  weight: 0,
}

export const internetScenarioF: Scenario = {
  id: 'internet-f',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.INTERNET,
  milestones: [
    provincesStep.id,
    currentProviderInternetD.id,
    internetSpeedOrHelp.id,
    internetSpeedD.id,
    peopleSimultaneously.id,
    howManyDevices.id,
    peopleWorkingFromHome.id,
    streamingVideoQuality.id,
    onlineGamingD.id,
    valueTheMostChoices1.id,
    // valueTheMostChoices2.id,
    postalCodeF.id,
    addressLocationInternet.id,
  ],
  version: '1',
  steps: [
    provincesStep,
    currentProviderInternetD,
    internetSpeedOrHelp,
    internetSpeedD,
    peopleSimultaneously,
    howManyDevices,
    peopleWorkingFromHome,
    streamingVideoQuality,
    onlineGamingD,
    valueTheMostChoices1,
    // valueTheMostChoices2,
    postalCodeF,
    addressLocationInternet,
  ],
  weight: 0,
}

export const internetScenarioG: Scenario = {
  id: 'internet-g',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.INTERNET,
  milestones: [
    provincesStep.id,
    currentProviderInternetD.id,
    internetSpeedOrHelp.id,
    internetSpeedG.id,
    sliderData.id,
    peopleSimultaneously.id,
    howManyDevices.id,
    peopleWorkingFromHome.id,
    streamingVideoQualityG.id,
    onlineGamingG.id,
    postalCodeF.id,
    addressLocationInternet.id,
  ],
  version: '2',
  steps: [
    provincesStep,
    currentProviderInternetD,
    internetSpeedOrHelp,
    internetSpeedG,
    sliderData,
    peopleSimultaneously,
    howManyDevices,
    peopleWorkingFromHome,
    streamingVideoQualityG,
    onlineGamingG,
    postalCodeF,
    addressLocationInternet,
  ],
  weight: 1,
}
